import { ParseOptions, parseUrl, StringifiableRecord, stringify, StringifyOptions } from 'query-string'

export const appendUrl = ({
  url,
  parseOptions,
  data,
  stringifyOptions
}: {
  url: string
  parseOptions: ParseOptions
  data: StringifiableRecord
  stringifyOptions: StringifyOptions
}) => {
  const oldData = parseUrl(url, parseOptions).query
  const newUrl = stringify({ ...oldData, ...data }, stringifyOptions)
  const urlObj = new URL(url, window.location.origin + window.location.pathname)
  return newUrl ? `${urlObj.origin}${urlObj.pathname}?${newUrl}` : `${urlObj.origin}${urlObj.pathname}`
}
